/* ==================================================
 * Pikaday
 * https://github.com/owenmead/Pikaday
 * ==================================================*/

(function () {

  'use strict';

  window.pickadayData = {
    format: 'DD MMMM YYYY'
  };

  $('[data-datepicker]').pikaday(pickadayData);

  window.timepickerData = {
    timeFormat: 'h:i A'
  };

  $('[data-timepicker]').timepicker(timepickerData);
})();
